import { type DurationLike } from 'luxon'
import { createContext } from 'react'
import type { ProofOfServicePhoto } from '../components/Map/OrderMap'
import { OrderServiceType, OrderStatus, type Order } from '@consumer/graphql'

interface AppContextValue {
  order?: Order
  setOrder: (order: Order) => void
  proofOfServicePhotos: ProofOfServicePhoto[]
  handleSetProofOfServicePhotos: (proofOfServicePhotos: ProofOfServicePhoto[]) => void
  clearOrder: () => void
}

export const INTERVAL_FROM_SIGN_IN: DurationLike = { days: 1 }
export const CHECK_SIGN_IN_INTERVAL = 60 * 60 * 1000 // 1 hour

export const defaultOrderState: Order = {
  orderId: '',
  packages: [],
  reroutableZipCodes: [],
  serviceType: OrderServiceType.Delivery,
  address: {}, // Empty object as default address
  clientDisplayName: '',
  consumerId: '',
  isEditable: false,
  isPastConsumerRerouteCutoff: false,
  isPastRerouteCutoff: false,
  clientName: '',
  calculatedOrderInformation: { orderDeliveryDates: [], orderStatus: {} as OrderStatus },
  calculatedPackagesInformation: {
    deliveredPackages: {
      groupedByDeliveredAtTime: [],
      total: 0,
    },
    notDeliveredPackages: {
      groupedByDeliveryDate: [],
      groupedByDeliveryWindow: [],
      groupedByEveningPackages: [],
      groupedByMissingDeliveryDate: [],
      total: 0,
    },
    pickedUpPackages: {
      groupedByPickedUpAtTime: [],
      total: 0,
    },
    notPickedUpPackages: {
      groupedByPickUpDate: [],
      groupedByPickUpWindow: [],
      groupedByEveningPackages: [],
      groupedByMissingPickUpDate: [],
      total: 0,
    },
    totalPackages: 0,
  },
  isOrderReroutable: false,
  isOrderReroutableByConsumer: false,
}

const AppDefaultState: AppContextValue = {
  order: defaultOrderState,
  setOrder: () => {
    /** @todo Implement setOrder */
  },
  proofOfServicePhotos: [],
  handleSetProofOfServicePhotos: () => {
    /** @todo Implement handleSetProofOfServicePhotos */
  },
  clearOrder: () => {
    /** @todo Implement clearOrder */
  },
}

export const AppContext = createContext<AppContextValue>(AppDefaultState)
